import { render } from "./securityPcIndex.vue?vue&type=template&id=394a0486"
import script from "./securityPcIndex.vue?vue&type=script&lang=js"
export * from "./securityPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__